/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_AvatarInputs */

const en_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar URL`)
};

const id_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL avatar`)
};

/**
* | output |
* | --- |
* | "Avatar URL" |
*
* @param {Settings_Profile_AvatarInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_profile_avatar = /** @type {((inputs?: Settings_Profile_AvatarInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_AvatarInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_profile_avatar(inputs)
	return en_settings_profile_avatar(inputs)
});